"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipStatus = void 0;
var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["Available"] = "Available";
    MembershipStatus["Exited"] = "Exited";
    MembershipStatus["Paused"] = "Paused";
})(MembershipStatus = exports.MembershipStatus || (exports.MembershipStatus = {}));
